import {
	PRODUCT_TYPE_ALL,
	PRODUCT_TYPE_EVO,
	PRODUCT_TYPE_NOVA
} from '../../dashboard/product-filter';

export const filterDownloadsByProductType = (downloads, productType) => {
	const selectedProductType = parseInt(productType);
	if (selectedProductType === PRODUCT_TYPE_ALL) {
		return (downloads || []).filter(download => {
			const downloadProductType = parseInt(download && (download.Product || download.ProductID));
			return downloadProductType === PRODUCT_TYPE_EVO ||
				downloadProductType === PRODUCT_TYPE_NOVA ||
				downloadProductType === 99;
		});
	}

	return (downloads || []).filter(download => {
		const downloadProductType = parseInt(download && (download.Product || download.ProductID));
		return downloadProductType === selectedProductType || downloadProductType === 99;
	});
};
